import Backbone from "backbone";
import IdentityAndAccessController from "../identity-and-access-controller";
import ResponsiveHelpers from "../responsive-helpers";
import Storage from "../storage";

/**
 * Router session management utility
 */
class RouterSessionManagement {

    /**
     * Detect if the route is a restricted route (Requires login)
     *
     * @returns {boolean} True if it is restricted
     */
    static get isRestrictedRoute () {
        const hash = this.currentHash;
        return ("" !== hash && "#forgot-password" !== hash && "#login" !== hash && "#?sessionEnded=1" !== hash);
    }

    /**
     * Get the current URL hash
     *
     * @returns {string} The current URL hash
     */
    static get currentHash () {
        let hash = "";

        if (undefined !== window && "location" in window) {
            hash = window.location.hash || "";
        }

        return hash;
    }

    /**
     * Determine what responsive helpers should be set (Login page)
     */
    static responsiveHelpers () {
        /**
         * Responsive helpers
         */
        if(!IdentityAndAccessController.sessionStatus && !this.isRestrictedRoute) {
            ResponsiveHelpers.setLoginView();
        } else {
            ResponsiveHelpers.unsetLoginView();
        }
    }

    /**
     * When the user navigates the application, we want to simply check some stuff (And override functionality if needed)
     *
     * @returns {boolean} True if the route should utilize the original navigation function.
     */
    static onRoute () {
        let shouldContinue = true;
        const hash = this.currentHash;
        const _redirect = Storage.getTemporaryStore("redirectUrl");

        this.responsiveHelpers();

        /**
         * If they went to a route that requires login, store the route & redirect them to login.
         * (After login, they get redirected back to that route)
         */
        if (!IdentityAndAccessController.sessionStatus && this.isRestrictedRoute) {

            Storage.setTemporaryStore({ key: "redirectUrl", value: hash });

            Backbone.history.navigate("/", {
                trigger: true,
                replace: true
            });

            shouldContinue = false;
        }

        /** Redirect to #dashboard if they went to one of the logged out routes. **/
        if(IdentityAndAccessController.sessionStatus && !this.isRestrictedRoute && null === _redirect) {
            Backbone.history.navigate("#dashboard", {
                trigger: true,
                replace: true
            });
            shouldContinue =  false;
        }

        /**
         * Redirect after login
         */
        if (IdentityAndAccessController.sessionStatus && null !== _redirect && hash !== _redirect) {

            Backbone.history.navigate(_redirect, {
                trigger: true,
                replace: true
            });

            Storage.deleteTemporaryStore("redirectUrl");

            shouldContinue =  false;
        }

        /** Refire session **/
        if (IdentityAndAccessController.sessionStatus) {
            IdentityAndAccessController.refireSession();
        }

        return shouldContinue;
    }

}

export default RouterSessionManagement;



// WEBPACK FOOTER //
// ./public/domain/controllers/router-session-management/index.js